export const CSV_UPLOAD_MENU = [
  { name: 'Address', path: 'address', csv_name: "ADDRESS", },
  { name: 'Brgy. Chairman', path: 'brgy-chairman', csv_name: "BRGY_CHAIRMAN", },
  { name: 'Business Establishment.', path: 'business-establishment', csv_name: "BUSINESS_ESTABLISHMENT" },
  { name: 'Citizenship', path: 'citizenship', csv_name: "CITIZENSHIP", },
  { name: 'Hospital', path: 'hospital', csv_name: "HOSPITAL", },
  { name: 'Institution', path: 'institution', csv_name: "INSTITUTION", },
  { name: 'Profession', path: 'profession', csv_name: "PROFESSION", },
  { name: 'Requirements', path: 'requirements', csv_name: "REQUIREMENTS", },
]

export const GET_CSV_LISTING = 'GET_CSV_LISTING/get_csv_listing';
export const CSV_UPLOAD_LISTING = 'api/v1/administrators/settings/csv_imports'
export const DOWNLOAD_FAILED = 'api/v1/administrators/settings/csv_imports/21/download_failed'
